import React, { useState } from "react";
import CustomDatePicker from "../components/CustomDatePicker";
import moment from "moment";

const BoCasinoBets = () => {
  const [filter, setFilter] = useState({
    from: moment().subtract(1, "day").format("YYYY-MM-DD HH:mm:ss"),
    to: moment().format("YYYY-MM-DD HH:mm:ss"),
  });
  return (
    <app-bogcasinoprovider _nghost-serverapp-c90 className="ng-star-inserted">
      <div
        _ngcontent-serverapp-c90
        className="full-wrap"
        style={{ height: "calc(100% - 105px)" }}
      >
        <div _ngcontent-serverapp-c90 className="over-wrap">
          <div _ngcontent-serverapp-c90 className="total_all">
            <span _ngcontent-serverapp-c90>
              <strong _ngcontent-serverapp-c90>BO Casino Bets</strong>
            </span>
            <div _ngcontent-serverapp-c90 className="spacer" />
            <span _ngcontent-serverapp-c90 className="total-users">
              {" "}
              Total Records: <strong _ngcontent-serverapp-c90>0</strong>
            </span>
            &nbsp;{" "}
            <span _ngcontent-serverapp-c90 className="total-users">
              {" "}
              Page Total PL:{" "}
              <strong _ngcontent-serverapp-c90 className="profit-text">
                0.00{" "}
              </strong>
            </span>
          </div>
          <div _ngcontent-serverapp-c90 className="function-wrap">
            <ul _ngcontent-serverapp-c90 className="input-list contentclass">
              <li _ngcontent-serverapp-c90>
                <label _ngcontent-serverapp-c90>Period:</label>
              </li>
              <CustomDatePicker
                type="new"
                filter={filter}
                setFilter={setFilter}
              />
            </ul>
            <ul _ngcontent-serverapp-c90 className="input-list diaplayflex">
              <li _ngcontent-serverapp-c90>
                <input
                  _ngcontent-serverapp-c90
                  appinputrestriction="noSpecialChars3"
                  type="text"
                  name
                  id
                  placeholder="Search Betid"
                  className="ng-untouched ng-pristine ng-valid"
                />
              </li>
              <li _ngcontent-serverapp-c90>
                <label _ngcontent-serverapp-c90>Stake</label>
                <input
                  _ngcontent-serverapp-c90
                  type="number"
                  name="Volume Check"
                  className="textfield-input ng-untouched ng-pristine ng-valid"
                  placeholder="Stake"
                />
              </li>
              <li _ngcontent-serverapp-c90>
                <label _ngcontent-serverapp-c90>Last:</label>
                <select
                  _ngcontent-serverapp-c90
                  name="limit"
                  id="limit"
                  className="ng-untouched ng-pristine ng-valid"
                >
                  <option _ngcontent-serverapp-c90 value={10}>
                    10 Txn
                  </option>
                  <option _ngcontent-serverapp-c90 value={25}>
                    25 Txn
                  </option>
                  <option _ngcontent-serverapp-c90 value={50}>
                    50 Txn
                  </option>
                  <option _ngcontent-serverapp-c90 value={100}>
                    100 Txn
                  </option>
                  <option _ngcontent-serverapp-c90 value={0}>
                    Full - 0
                  </option>
                </select>
              </li>
              <li _ngcontent-serverapp-c90>
                <label _ngcontent-serverapp-c90>Sort by:</label>
                <select
                  _ngcontent-serverapp-c90
                  name="limit"
                  id="limit"
                  className="ng-untouched ng-pristine ng-valid"
                >
                  <option _ngcontent-serverapp-c90 value={1}>
                    Bet Settled Time
                  </option>
                  <option _ngcontent-serverapp-c90 value={0}>
                    Bet Taken Time
                  </option>
                </select>
              </li>
              <li _ngcontent-serverapp-c90 />
              <li _ngcontent-serverapp-c90>
                <a _ngcontent-serverapp-c90 id="getPL" className="btn-send">
                  Get History
                </a>
              </li>
              {/**/}
            </ul>
          </div>
          <div _ngcontent-serverapp-c90 className="table-responsive data-table">
            <div _ngcontent-serverapp-c90 id="report">
              <table
                _ngcontent-serverapp-c90
                id="table_DL"
                className="table-s"
                style={{ display: "table" }}
              >
                <tbody _ngcontent-serverapp-c90>
                  <tr _ngcontent-serverapp-c90>
                    {/**/}
                    {/**/}
                    <th
                      _ngcontent-serverapp-c90
                      width="5%"
                      data-order="asc"
                      data-name="playerId"
                      className="align-L sort_asc ng-star-inserted"
                    >
                      {" "}
                      SA ID{" "}
                    </th>
                    {/**/}
                    {/**/}
                    {/**/}
                    <th
                      _ngcontent-serverapp-c90
                      width="5%"
                      data-order="asc"
                      data-name="playerId"
                      className="align-L sort_asc ng-star-inserted"
                    >
                      {" "}
                      SM ID{" "}
                    </th>
                    {/**/}
                    {/**/}
                    {/**/}
                    <th
                      _ngcontent-serverapp-c90
                      width="5%"
                      data-order="asc"
                      data-name="playerId"
                      className="align-L sort_asc ng-star-inserted"
                    >
                      {" "}
                      MA ID{" "}
                    </th>
                    {/**/}
                    {/**/}
                    {/**/}
                    <th
                      _ngcontent-serverapp-c90
                      width="5%"
                      data-name="playerId"
                      className="align-L"
                    >
                      PL ID{" "}
                    </th>
                    <th
                      _ngcontent-serverapp-c90
                      width="5%"
                      data-name="consolidateId"
                      className="align-L"
                    >
                      Round Id{" "}
                    </th>
                    <th
                      _ngcontent-serverapp-c90
                      id="betTime"
                      width="6%"
                      data-name="betTime"
                      className="align-L"
                    >
                      Bet taken{" "}
                    </th>
                    <th
                      _ngcontent-serverapp-c90
                      id="betTime"
                      width="7%"
                      data-name="settlementTime"
                      className="align-L"
                    >
                      {" "}
                      Bet Settled{" "}
                    </th>
                    <th
                      _ngcontent-serverapp-c90
                      width="7%"
                      data-name="eventName"
                      className="align-L"
                    >
                      {" "}
                      Platform{" "}
                    </th>
                    <th
                      _ngcontent-serverapp-c90
                      width="5%"
                      data-name="sportname"
                      className="align-L"
                    >
                      {" "}
                      GameName{" "}
                    </th>
                    <th
                      _ngcontent-serverapp-c90
                      width="5%"
                      data-order="asc"
                      data-name="stake"
                      className="sort_asc"
                    >
                      Stake{" "}
                    </th>
                    <th
                      _ngcontent-serverapp-c90
                      width="5%"
                      name="profitOrLossTh"
                      data-order="asc"
                      data-name="roundPL"
                      className="sort_asc"
                    >
                      {" "}
                      Profit/Loss
                    </th>
                    <th
                      _ngcontent-serverapp-c90
                      width="5%"
                      name="status"
                      data-name="status"
                    >
                      {" "}
                      Status
                    </th>
                    {/**/}
                  </tr>
                  {/**/}
                </tbody>
              </table>
            </div>
            {/**/}
          </div>
        </div>
      </div>
      <app-modal _ngcontent-serverapp-c90 _nghost-serverapp-c43>
        <div
          _ngcontent-serverapp-c43
          id="createModal"
          className="pop_bg"
          style={{ height: "100%", width: "100%", display: "none" }}
        >
          <div
            _ngcontent-serverapp-c43
            className="pop_box pop_refer"
            style={{ width: "690px" }}
          >
            <a
              _ngcontent-serverapp-c43
              href="#"
              className="close_pop ng-star-inserted"
            >
              close_pop
            </a>
            {/**/}
            <h3 _ngcontent-serverapp-c90 style={{ display: "flex" }}>
              Confirm Void Bet{" "}
              <a _ngcontent-serverapp-c90 className="close_pop">
                close_pop
              </a>
            </h3>
            <div _ngcontent-serverapp-c90 className="modal-content">
              <table _ngcontent-serverapp-c90 className="table-s">
                <tbody _ngcontent-serverapp-c90>
                  <tr _ngcontent-serverapp-c90>
                    <th _ngcontent-serverapp-c90>UID</th>
                    <th _ngcontent-serverapp-c90>Bet ID</th>
                    <th _ngcontent-serverapp-c90>Event</th>
                    <th _ngcontent-serverapp-c90>Bet Placed</th>
                    <th _ngcontent-serverapp-c90>PL</th>
                    <th _ngcontent-serverapp-c90>Stake</th>
                  </tr>
                  <tr _ngcontent-serverapp-c90>
                    <td _ngcontent-serverapp-c90 />
                    <td _ngcontent-serverapp-c90 />
                    <td _ngcontent-serverapp-c90>
                      {" "}
                      <img
                        _ngcontent-serverapp-c90
                        src="/assets/images/transparent.gif"
                        className="fromto"
                      />
                    </td>
                    <td _ngcontent-serverapp-c90>
                      <span
                        _ngcontent-serverapp-c90
                        id="betPlaced"
                        className="small-date"
                      >
                        {" "}
                      </span>
                    </td>
                    <td _ngcontent-serverapp-c90>
                      <span _ngcontent-serverapp-c90 />
                    </td>
                    <td _ngcontent-serverapp-c90 />
                  </tr>
                </tbody>
              </table>
            </div>
            <form
              _ngcontent-serverapp-c90
              noValidate
              className="ng-untouched ng-pristine ng-invalid"
            >
              <ul _ngcontent-serverapp-c90 className="btn-wrap">
                <li _ngcontent-serverapp-c90>
                  <label _ngcontent-serverapp-c90>Password:</label>
                  <input
                    _ngcontent-serverapp-c90
                    id="password"
                    type="password"
                    formcontrolname="password"
                    required
                    placeholder="Enter"
                    className="ng-untouched ng-pristine ng-invalid"
                  />
                </li>
                <li _ngcontent-serverapp-c90>
                  <button
                    _ngcontent-serverapp-c90
                    type="submit"
                    className="btn-send"
                  >
                    {" "}
                    Submit{" "}
                  </button>
                </li>
              </ul>
            </form>
          </div>
        </div>
      </app-modal>
      <app-modal _ngcontent-serverapp-c90 _nghost-serverapp-c43>
        <div
          _ngcontent-serverapp-c43
          id="createModal"
          className="pop_bg"
          style={{ height: "100%", width: "100%", display: "none" }}
        >
          <div
            _ngcontent-serverapp-c43
            className="pop_box pop_refer"
            style={{ width: "690px" }}
          >
            <a
              _ngcontent-serverapp-c43
              href="#"
              className="close_pop ng-star-inserted"
            >
              close_pop
            </a>
            {/**/}
            <h3 _ngcontent-serverapp-c90 style={{ display: "flex" }}>
              Confirm Void Bet{" "}
              <a _ngcontent-serverapp-c90 className="close_pop">
                close_pop
              </a>
            </h3>
            <div _ngcontent-serverapp-c90 className="modal-content">
              <table _ngcontent-serverapp-c90 className="table-s">
                <tbody _ngcontent-serverapp-c90>
                  <tr _ngcontent-serverapp-c90>
                    <th _ngcontent-serverapp-c90>UID</th>
                    <th _ngcontent-serverapp-c90>Bet ID</th>
                    <th _ngcontent-serverapp-c90>Event</th>
                    <th _ngcontent-serverapp-c90>Bet Placed</th>
                    <th _ngcontent-serverapp-c90>PL</th>
                    <th _ngcontent-serverapp-c90>Stake</th>
                    <th _ngcontent-serverapp-c90>Action</th>
                  </tr>
                  {/**/}
                </tbody>
              </table>
            </div>
            <form
              _ngcontent-serverapp-c90
              noValidate
              className="ng-untouched ng-pristine ng-invalid"
            >
              <ul _ngcontent-serverapp-c90 className="btn-wrap">
                <li _ngcontent-serverapp-c90>
                  <label _ngcontent-serverapp-c90>Password:</label>
                  <input
                    _ngcontent-serverapp-c90
                    id="password"
                    type="password"
                    formcontrolname="password"
                    required
                    placeholder="Enter"
                    className="ng-untouched ng-pristine ng-invalid"
                  />
                </li>
                <li _ngcontent-serverapp-c90>
                  <button
                    _ngcontent-serverapp-c90
                    type="submit"
                    className="btn-send"
                  >
                    {" "}
                    Submit{" "}
                  </button>
                </li>
              </ul>
            </form>
          </div>
        </div>
      </app-modal>
    </app-bogcasinoprovider>
  );
};

export default BoCasinoBets;
